export default __webpack_public_path__ + "static/media/Mark-5-Suit-03.d73b040e.jpg";